const doc = [({"zh_cn":({"adminButtonHotelCheckIn":({"addGuest":"添加客人", "addRoom":"添加房间", "deleteGuest":"删除访客", "deleteRoom":"删除客房", "setUpMembership":"设置会员资格"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;